module.exports = __webpack_public_path__ + "static/media/guitar-electric.72b1df4d.svg";